import * as tslib_1 from "tslib";
import * as React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { API_URL, ATTACH_SERVER, SITE_URL } from "../../config/urls";
// @ts-ignore
import Dropzone from 'react-dropzone';
import { withRouter } from "react-router";
import { Typeahead } from 'react-bootstrap-typeahead';
import { number } from "prop-types";
import 'jodit';
import 'jodit/build/jodit.min.css';
import JoditWrapper from "./editor";
// @ts-ignore
import Clipboard from 'react-clipboard.js';
import { toastr } from "react-redux-toastr";
var qs = require("qs");
var NewsEdit = /** @class */ (function (_super) {
    tslib_1.__extends(NewsEdit, _super);
    function NewsEdit(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            searching: false,
            loading: true,
            title: '',
            description: '',
            source: '',
            tags: [],
            image: '',
            image_id: 0,
            pictures: [],
            short_desc: '',
        };
        return _this;
    }
    NewsEdit.prototype.componentWillMount = function () {
        if (this.props.match.params.id > 0) {
            this.Get();
        }
    };
    NewsEdit.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col col-xs-2 pull-left" },
                    React.createElement("h3", null,
                        this.props.match.params.id > 0 ? 'Редактирование' : 'Создание',
                        " \u043D\u043E\u0432\u043E\u0441\u0442\u0438")),
                React.createElement("div", { className: "col col-xs-2 pull-left" }, this.props.match.params.id > 0 ? (React.createElement("button", { onClick: this.Update.bind(this), className: "btn btn-primary" }, "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C")) : (React.createElement("button", { onClick: this.Create.bind(this), className: "btn btn-primary" }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"))),
                (this.props.match.params.id > 0) && (React.createElement("div", { className: "col col-xs-2 pull-left" },
                    React.createElement("a", { target: '_blank', href: SITE_URL + '/news-preview/' + this.props.match.params.id + '?token=' + this.props.auth_token, className: "btn btn-primary" }, "\u041F\u0440\u0435\u0434\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440"))),
                React.createElement("div", { className: "col col-xs-2 pull-left" },
                    (this.props.match.params.id > 0 && !this.state.active) && (React.createElement("button", { onClick: function () {
                            _this.setState({ active: !_this.state.active }, function () {
                                _this.Update();
                            });
                        }, className: "btn btn-success" }, "\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C")),
                    (this.props.match.params.id > 0 && this.state.active) && (React.createElement("button", { onClick: function () {
                            _this.setState({ active: !_this.state.active }, function () {
                                _this.Update();
                            });
                        }, className: "btn btn-success" }, "\u0421\u043D\u044F\u0442\u044C \u0441 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438"))),
                React.createElement("div", { className: "col col-xs-2 pull-left" },
                    (this.props.match.params.id > 0 && !this.state.main) && (React.createElement("button", { onClick: this.OnTop.bind(this, true), className: "btn btn-info" }, "\u0417\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u043D\u0430 \u0441\u0430\u0439\u0442\u0435")),
                    (this.props.match.params.id > 0 && this.state.main) && (React.createElement("button", { onClick: this.OnTop.bind(this, false), className: "btn btn-info" }, "\u041E\u0442\u043A\u0440\u0435\u043F\u0438\u0442\u044C")))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "form-group", style: { width: '100%' } },
                    "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A",
                    React.createElement("input", { className: "form-control cols-xs-12", name: "id", onChange: function (e) {
                            var value = e.target.value;
                            _this.setState({
                                title: value,
                            });
                        }, value: this.state.title, type: "text" })),
                React.createElement("br", null),
                React.createElement("div", { className: "form-group", style: { width: '100%' } },
                    "\u041A\u043E\u0440\u043E\u0442\u043A\u043E\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435(\u0434\u043B\u044F \u0441\u043F\u0438\u0441\u043A\u0430)",
                    React.createElement("textarea", { className: "form-control cols-xs-12", name: "id", onChange: function (e) {
                            var value = e.target.value;
                            _this.setState({
                                short_desc: value,
                            });
                        }, value: this.state.short_desc })),
                React.createElement("br", null),
                React.createElement("div", { className: "form-group", style: { width: '100%' } },
                    "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
                    React.createElement("br", null),
                    "\u0414\u043B\u044F \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0439 \u0432\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435\u0441\u044C \u043A\u043D\u043E\u043F\u043A\u043E\u0439 \"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C\" \u043F\u043E\u0434 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u043E\u043C. \u0417\u0430\u0442\u0435\u043C \u0441\u043A\u043E\u043F\u0438\u0440\u0443\u0439\u0442\u0435 \u0441\u0441\u044B\u043B\u043A\u0443 \u043D\u0430 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043D\u044B\u0439 \u0444\u0430\u0439\u043B, \u043A\u043B\u0438\u043A\u043D\u0443\u0432 \u043D\u0430 \u043F\u0440\u0435\u0432\u044C\u044E.",
                    React.createElement("br", null),
                    "\u0412 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0435 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u0438\u043A\u043D\u043E\u043A\u0443 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F, \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0441\u0441\u044B\u043B\u043A\u0443 \u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \"\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C\"",
                    React.createElement(JoditWrapper, { initValue: this.state.description, onContentUpdate: function (value) {
                            _this.setState({ description: value });
                        } })),
                React.createElement("div", { className: "form-group" },
                    React.createElement("label", { className: "label-small" }, "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F(\u043A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u043D\u0430 \u043F\u0440\u0435\u0432\u044C\u044E \u0434\u043B\u044F \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0441\u044B\u043B\u043A\u0438)"),
                    React.createElement(Dropzone, { onDrop: this.onImagesDrop.bind(this, function (link) {
                            _this.setState(function (prevState) {
                                var pictures = prevState.pictures;
                                pictures.push(link);
                                return { pictures: pictures };
                            });
                        }, 'md'), multiple: false, accept: "image/*", maxSize: 8000000 }, function (_a) {
                        var 
                        // @ts-ignore
                        getRootProps = _a.getRootProps, getInputProps = _a.getInputProps;
                        return (React.createElement("div", tslib_1.__assign({}, getRootProps(), { style: {
                                width: '100%',
                                height: '40px',
                                borderWidth: '0',
                                borderRadius: '5px',
                                borderStyle: 'dashed',
                                textAlign: 'left'
                            } }),
                            React.createElement("input", tslib_1.__assign({}, getInputProps())),
                            React.createElement("button", { type: "button", className: "btn btn-primary btn-sm" }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C")));
                    }),
                    this.state.pictures.map(function (picture, i) { return (React.createElement("div", { key: 'quiz-image-' + i, style: { width: 50 } },
                        React.createElement("div", { className: "removeLogo", onClick: function () { return _this.setState(function (prevState) {
                                var pictures = prevState.pictures;
                                pictures.splice(i, 1);
                                return { pictures: pictures };
                            }); }, style: {
                                cursor: 'pointer',
                                fontSize: 24
                            } }, "\u00D7"),
                        React.createElement(Clipboard, { "data-clipboard-text": picture, onSuccess: function () { toastr.success("Успех", 'Ссылка скопирована'); } },
                            React.createElement("img", { className: "img-responsive", width: 100, height: 'auto', src: picture })),
                        React.createElement("span", null, picture))); })),
                React.createElement("br", null),
                React.createElement("div", { className: "form-group", style: { width: '100%' } },
                    "\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A",
                    React.createElement("input", { className: "form-control cols-xs-12", name: "id", onChange: function (e) {
                            var value = e.target.value;
                            _this.setState({
                                source: value,
                            });
                        }, value: this.state.source, type: "text" })),
                React.createElement("br", null),
                React.createElement("div", { className: "form-group", style: { width: '100%' } },
                    "\u0422\u044D\u0433\u0438",
                    React.createElement(Typeahead, { allowNew: true, multiple: true, onChange: function (e) {
                            _this.setState({ tags: e });
                        }, selected: this.state.tags, newSelectionPrefix: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C: ", options: this.state.tags, placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u044D\u0433\u0438..." })),
                React.createElement("div", { className: "form-group" },
                    "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u0441\u043F\u0438\u0441\u043A\u0430",
                    React.createElement("br", null),
                    this.state.image.length > 0 && (React.createElement("img", { width: "150", height: "auto", src: this.state.image })),
                    React.createElement("input", { type: 'file', onChange: function (e) {
                            if (e.target.files) {
                                _this.handleChange(e.target.files);
                            }
                            e.target.value = '';
                        } })))));
    };
    NewsEdit.prototype.Get = function () {
        var _this = this;
        axios.get(API_URL + "/news/" + this.props.match.params.id, { headers: { 'Authorization': this.props.auth_token } }).then(function (r) {
            if (r.data && r.data.data && r.data.code === 200) {
                var n = r.data.data;
                var t_1 = [];
                n.tags.forEach(function (tag, index) {
                    t_1.push({ label: tag, value: number });
                });
                n.tags = t_1;
                _this.setState(tslib_1.__assign({}, n));
            }
        }).catch(function (e) {
            console.log(e);
        });
    };
    NewsEdit.prototype.Create = function () {
        var _this = this;
        if (this.state.title.length < 1) {
            toastr.error("Ошибка", "Отсутствует заголовок новости");
            return;
        }
        if (this.state.description.length < 1) {
            toastr.error("Ошибка", "Отсутствует описание новости");
            return;
        }
        if (this.state.short_desc.length < 1) {
            toastr.error("Ошибка", "Отсутствует краткое описание новости");
            return;
        }
        var tags = [];
        this.state.tags.forEach(function (t) {
            tags.push(t.label);
        });
        axios.post(API_URL + "/news", qs.stringify({
            title: this.state.title,
            description: this.state.description,
            short_desc: this.state.short_desc,
            active: false,
            source: this.state.source,
            tags: JSON.stringify(tags),
            image_id: this.state.image_id,
        }), { headers: { 'Authorization': this.props.auth_token } })
            .then(function (r) {
            if (r.data && r.data.code && Number(r.data.code) === 201) {
                toastr.success("Успех", "Новость создана");
                _this.props.history.push('/news/');
            }
        }).catch(function (e) { return console.log(e); });
    };
    NewsEdit.prototype.Update = function () {
        if (this.state.title.length < 1) {
            toastr.error("Ошибка", "Отсутствует заголовок новости");
            return;
        }
        if (this.state.description.length < 1) {
            toastr.error("Ошибка", "Отсутствует описание новости");
            return;
        }
        if (this.state.short_desc.length < 1) {
            toastr.error("Ошибка", "Отсутствует краткое описание новости");
            return;
        }
        var tags = [];
        this.state.tags.forEach(function (t) {
            tags.push(t.label);
        });
        axios.put(API_URL + "/news/" + this.props.match.params.id, qs.stringify({
            title: this.state.title,
            description: this.state.description,
            short_desc: this.state.short_desc,
            source: this.state.source,
            active: this.state.active,
            tags: JSON.stringify(tags),
            image_id: this.state.image_id,
        }), { headers: { 'Authorization': this.props.auth_token } })
            .then(function (r) {
            if (r.data && r.data.code && Number(r.data.code) === 200) {
                toastr.success("Успех", "Новость обновлена");
            }
        }).catch(function (e) { return console.log(e); });
    };
    NewsEdit.prototype.handleChange = function (files) {
        var _this = this;
        var file = files[0];
        var img = new Image();
        img.onload = function () {
            var data = new FormData();
            data.append('upload', file);
            axios.post(ATTACH_SERVER + '/upload/', data, {
                headers: {
                    'Authorization': 'Bearer ' + _this.props.auth_token,
                },
            })
                .then(function (res) {
                _this.setState({ image_id: res.data.data.id, image: res.data.data.link_to_thumb });
            })
                .catch(function (err) {
                if (err.response && err.response.data && err.response.data.error) {
                    toastr.error('Ошибка', err.response.data.error);
                }
            });
        };
        img.src = URL.createObjectURL(files[0]);
    };
    NewsEdit.prototype.onImagesDrop = function (callback, type, files) {
        this.handleImagesUpload(files, callback, type);
    };
    NewsEdit.prototype.handleImagesUpload = function (files, callback, type) {
        var data = new FormData();
        data.append('upload', files[0]);
        axios.post(ATTACH_SERVER + '/upload/', data, {
            headers: {
                'Authorization': 'Bearer ' + this.props.auth_token,
            },
        })
            .then(function (res) {
            axios.get(ATTACH_SERVER + '/attach/' + res.data.data.id).then(function (resp) {
                callback(resp.data.data.link);
            }).catch(function (err) {
                toastr.error('Ошибка', err);
            });
        })
            .catch(function (err) {
            if (err.response && err.response.data && err.response.data.error) {
                toastr.error('Ошибка', err.response.data.error);
            }
        });
    };
    NewsEdit.prototype.OnTop = function (b) {
        var _this = this;
        if (confirm("Вы действительно хотите закрепить/открепить новость?")) {
            axios.post(API_URL + "/news/on-top/" + this.props.match.params.id, qs.stringify({
                top: b
            }), { headers: { 'Authorization': this.props.auth_token } })
                .then(function (r) {
                if (r.data && r.data.code && Number(r.data.code) === 200) {
                    toastr.success("Успех", "Новость обновлена");
                    _this.setState({ main: b });
                }
            }).catch(function (e) { return console.log(e); });
        }
    };
    return NewsEdit;
}(React.Component));
export default withRouter(connect(function (state) { return ({
    auth_token: state.app.get("auth_token"),
    isAdmin: state.app.get("is_sadmin"),
}); })(NewsEdit));



//////////////////
// WEBPACK FOOTER
// ./src/views/news/edit.tsx
// module id = 543
// module chunks = 0